export default {
  getCustomerData: state => state.customerEdited,
  getCustomers: state => state.customers,
}
